import React, { useState } from 'react';
import { contactData } from '../mock';
import { Mail, MessageCircle, Linkedin, Copy, Check } from 'lucide-react';

const Contact = () => {
  const [copiedTelegram, setCopiedTelegram] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState(false);

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text);
    if (type === 'telegram') {
      setCopiedTelegram(true);
      setTimeout(() => setCopiedTelegram(false), 2000);
    } else {
      setCopiedEmail(true);
      setTimeout(() => setCopiedEmail(false), 2000);
    }
  };

  // Mask email for display but keep full email for copying
  const maskEmail = (email) => {
    const [localPart, domain] = email.split('@');
    if (localPart.length <= 2) return email;
    return `${localPart[0]}${'*'.repeat(Math.min(localPart.length - 1, 10))}@${domain}`;
  };

  // Mask telegram handle for display but keep full handle for copying
  const maskTelegram = (handle) => {
    if (handle.length <= 3) return handle;
    return `${handle.substring(0, 2)}${'*'.repeat(Math.min(handle.length - 2, 8))}`;
  };

  return (
    <footer className="contact-section-clean">
      <div className="contact-container-clean">
        <h2 className="contact-title-clean">Let's Connect</h2>
        <p className="contact-subtitle-clean">
          Ready to build the future of Web3, AI, robotics and emerging tech?
        </p>

        <div className="contact-links">
          <div className="contact-box">
            <MessageCircle size={20} />
            <span>Telegram - {maskTelegram(contactData.telegram)}</span>
            <button 
              className="copy-btn"
              onClick={() => copyToClipboard(contactData.telegram, 'telegram')}
              title="Copy Telegram handle"
            >
              {copiedTelegram ? <Check size={16} /> : <Copy size={16} />}
            </button>
          </div>

          <div className="contact-box">
            <Mail size={20} />
            <span>{maskEmail(contactData.email)}</span>
            <button 
              className="copy-btn"
              onClick={() => copyToClipboard(contactData.email, 'email')}
              title="Copy email address"
            >
              {copiedEmail ? <Check size={16} /> : <Copy size={16} />}
            </button>
          </div>

          <a
            href={contactData.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <Linkedin size={20} />
            <span>LinkedIn</span>
          </a>
        </div>

        <div className="footer-bottom-clean">
          <p>© 2025 Shailey Singh. Marketing & Growth Professional.</p>
          <p className="footer-tagline-clean">
            Building narratives that move complex problems to seamless adoption.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Contact;